import { displayManager, THREE } from '@powerplay/common';
export class RenderManager {
    renderer;
    MAX_RENDER_WIDTH = 2560;
    create() {
        this.renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true
        });
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.outputEncoding = THREE.sRGBEncoding;
        this.setSize(100);
        const canvasElement = document.getElementById('game-container');
        if (canvasElement)
            canvasElement.appendChild(this.renderer.domElement);
    }
    getDomElement() {
        return this.renderer.domElement;
    }
    setSize(quality) {
        let width = displayManager.width;
        let height = displayManager.height;
        const maxRenderWidth = this.MAX_RENDER_WIDTH / window.devicePixelRatio;
        if (width > maxRenderWidth) {
            height *= (maxRenderWidth / width);
            width = maxRenderWidth;
        }
        const qualityCoef = quality / 100;
        width = Math.round(qualityCoef * width);
        height = Math.round(qualityCoef * height);
        this.renderer.setSize(width, height, false);
    }
    renderScene(scene, camera) {
        this.renderer.render(scene, camera);
    }
}
//# sourceMappingURL=RenderManager.js.map